import { Controller } from '@hotwired/stimulus';
export default class extends Controller {
  static targets = ['main', 'form', 'formwrapper', 'editbtn', 'cancelbtn']

  calculateFormHeight() {
    const formEl = this.formwrapperTarget;
    const actualHeight = formEl.getBoundingClientRect().height;
    this.formTarget.style.height = `${actualHeight}px`;
  }

  show() {
    this.calculateFormHeight()
    this.formwrapperTarget.classList.remove('-translate-y-[100%]')
    this.editbtnTarget.classList.add('!hidden')
    this.cancelbtnTarget.classList.remove('!hidden')
    this.mainTarget.classList.add('rounded-bl-none')
    this.mainTarget.classList.add('rounded-br-none')
  }

  hide() {
    this.formTarget.style.height = ``;
    this.formwrapperTarget.classList.add('-translate-y-[100%]')
    this.editbtnTarget.classList.remove('!hidden')
    this.cancelbtnTarget.classList.add('!hidden')
    this.mainTarget.classList.remove('rounded-bl-none')
    this.mainTarget.classList.remove('rounded-br-none')
  }
}